export default "__VITE_PUBLIC_ASSET__35015b80__"